import Seo from "./Seo";
import { useT, useLang } from "../i18n/LanguageContext";

// Reusable dark editorial layout for legal pages.
export default function LegalLayout({ title, subtitle, updated, seoTitle, seoDesc, path, children }) {
  const t = useT();
  const { lang } = useLang();
  return (
    <div className="pt-28 pb-24 px-6 md:px-12">
      <Seo title={seoTitle} description={seoDesc} path={path} locale={lang === "it" ? "it_IT" : "en_US"} />
      <div className="max-w-3xl mx-auto">
        <p className="overline mb-4">{t("legal.overline")}</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light leading-none mb-4">
          {title}
        </h1>
        {subtitle && <p className="text-white/60 mt-4 leading-relaxed">{subtitle}</p>}
        <p className="text-white/40 text-sm mt-4 mb-16">{t("legal.updated")} {updated || new Date().getFullYear()}</p>
        <div className="space-y-12">{children}</div>
      </div>
    </div>
  );
}

export const LegalSection = ({ title, children }) => (
  <section>
    {title && <h2 className="font-serif text-2xl md:text-3xl text-[#C5A059] mb-4">{title}</h2>}
    <div className="text-white/70 leading-relaxed space-y-3 text-sm md:text-base">{children}</div>
  </section>
);
